<template>
  <a
    class="glossary"
    :href="`${homepageUrl}glossary/${randomItem.url_param}/`"
    target="_blank"
  >
    <div
      class="gw_box flex-1"
      style="--box-padding: 0"
    >
      <div class="gw_box gw_box_widget_title">
        {{ $t('glossary.title') }}

        <div
          class="mdi mdi-chevron-right clr-white ml-auto text-large line-height_1 pa-1 icon_btn csst csst_nm"
        >
          <div
            class="csst_content text-nowrap"
            style="left: -0.25em; transform: translate(-100%, 0)"
            v-html="$t('tooltips.see_glossary')"
          ></div>
        </div>
      </div>
      <div
        class="gw_box glossary_content"
        style="--box-padding: 1.125rem"
      >
        <div class="f-center">
          <!-- <div v-html="$t('glossary.what_is_xxx', { term: randomItem.name })"></div> -->
          <!-- <div
            class="clr-grey weight_600 text-semi-large"
            v-html="$t('glossary.what_is')"
          ></div> -->
          <!-- <div class="f-center clr-white mt-2">
            <Logo style="fill: currentColor; width: 2.375rem" />
          </div> -->
          <!-- <div class="text-big weight_600 ml-auto clr-grey">
            #{{ todaysDD.index + 1 }}
          </div> -->
          <div class="ml-auto"></div>
        </div>
        <div
          class="text-large text-underline_hover weight_600 uppercase clr-primary text-break-alls"
        >
          <!-- mt-4 -->
          {{ randomItem.name }}
        </div>
        <div class="glossary_sub text-medium clr-grey mt-2">
          <!-- 66chars -->
          <!-- asdasdasdasdsadaasdasdasdasdxxxsssssssswwwwwwwwwwwwwweeeeeeeeeeecswwweeerrr -->
          {{ randomItem.text }}
        </div>
      </div>
    </div>
  </a>
</template>

<script>
// import Logo from '@/assets/logo.svg'
import glossary from '@/assets/glossary.json'

export default {
  name: 'GlossaryWidget',
  components: {
    // Logo,
  },
  data() {
    return {}
  },

  computed: {
    randomItem() {
      let res = glossary
      res = res[Math.floor(res.length * Math.random())] || res[0]
      // console.log(glossary, res)
      return res
    },
    homepageUrl() {
      const homepageUrl = `https://${window.location.hostname.replace('app.', '')}/`
      return homepageUrl
    },
  },
}
</script>
<style lang="scss" scoped>
.glossary {
  &_sub {
    max-width: 19rem; // glossary cub si cut to 80 chars
    // word-break: break-all;
    --line-clamp: 2;
    // --line-clamp: 1;
    display: -webkit-box;
    -webkit-line-clamp: var(--line-clamp);
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
@media (hover: hover) and (pointer: fine) {
  .glossary {
    &_content {
      z-index: 1;
      &::before {
        content: '';
        // background: rgba(255, 255, 255, 0.05);
        background: var(--clr-black-1-3);
        height: calc(100% - 1rem);
        width: calc(100% - 1rem);
        left: 0.5rem;
        top: 0.5rem;
        // left: 0;
        position: absolute;
        border-radius: 4px;
        overflow: hidden;
        z-index: 0;
        opacity: 0;
        z-index: -1;
        transition: opacity 0.2s ease;
      }
      &:hover {
        &::before {
          opacity: 1;
        }
      }
    }
  }
}
</style>
